let ctx;

const TONES = {
  info: { freq: [660, 880], gain: 0.16, dur: 0.22, gap: 0.14 },
  success: { freq: [784, 1046], gain: 0.16, dur: 0.22, gap: 0.14 },
  warning: { freq: [520, 415], gain: 0.16, dur: 0.22, gap: 0.14 },
  error: { freq: [415, 300], gain: 0.16, dur: 0.22, gap: 0.14 },
  /* Alarm prioritas: sirine naik-turun, jauh lebih keras dan panjang. */
  alarm: { freq: [1180, 760, 1180, 760, 1180], gain: 0.95, dur: 0.3, gap: 0.26, type: "square" },
};

/** Nada notifikasi (WebAudio, tanpa file audio). */
export function playChime(kind = "info") {
  if (localStorage.getItem("ab_sound") === "off") return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const t = TONES[kind] || TONES.info;
    t.freq.forEach((f, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = t.type || "sine";
      osc.frequency.value = f;
      const t0 = ctx.currentTime + i * t.gap;
      gain.gain.setValueAtTime(0.0001, t0);
      gain.gain.exponentialRampToValueAtTime(t.gain, t0 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + t.dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t0);
      osc.stop(t0 + t.dur + 0.02);
    });
  } catch (e) {
    console.error("audio notifikasi tidak didukung:", e);
  }
}

/** Getar HP mengikuti alarm (diabaikan bila perangkat tidak mendukung). */
export function buzz(pattern = [400, 150, 400, 150, 700]) {
  try {
    navigator.vibrate?.(pattern);
  } catch (e) {
    console.error("getar tidak didukung:", e);
  }
}

export const soundEnabled = () => localStorage.getItem("ab_sound") !== "off";
export const toggleSound = () => {
  const next = soundEnabled() ? "off" : "on";
  localStorage.setItem("ab_sound", next);
  return next === "on";
};
